/* eslint-disable max-len */
import { HeartIcon as SourceHeartIcon } from 'SourceComponent/HeartIcon/HeartIcon.component';

import './HeartIcon.style';

/** @namespace Bodypwa/Component/HeartIcon/Component */
export class HeartIconComponent extends SourceHeartIcon {
    render() {
        const { isActive } = this.props;

        if (isActive) {
            return (
                <svg
                  block="HeartIcon"
                  mods={ { isActive } }
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                    <path fillRule="evenodd" clipRule="evenodd" d="M10 1.52325C7.64263 -0.583323 4.02174 -0.504937 1.7584 1.7584C-0.586135 4.10294 -0.586132 7.90418 1.7584 10.2487L10 18.4903L18.2416 10.2487C20.5861 7.90418 20.5861 4.10293 18.2416 1.7584C15.9783 -0.504936 12.3574 -0.583323 10 1.52325Z" fill="#070707" />
                </svg>
            );
        }

        return (
            <svg
              block="HeartIcon"
              mods={ { isActive } }
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path fillRule="evenodd" clipRule="evenodd" d="M10 1.52325C7.64263 -0.583323 4.02174 -0.504937 1.7584 1.7584C-0.586135 4.10294 -0.586132 7.90418 1.7584 10.2487L10 18.4903L18.2416 10.2487C20.5861 7.90418 20.5861 4.10293 18.2416 1.7584C15.9783 -0.504936 12.3574 -0.583323 10 1.52325ZM8.65562 3.35149C7.19093 1.88679 4.81618 1.88679 3.35149 3.35149C1.88679 4.81618 1.88679 7.19093 3.35149 8.65563L10 15.3041L16.6485 8.65563C18.1132 7.19093 18.1132 4.81618 16.6485 3.35149C15.1838 1.88679 12.8091 1.88679 11.3444 3.35149L10 4.69586L8.65562 3.35149Z" />
            </svg>
        );
    }
}

export default HeartIconComponent;
